module.exports = __webpack_public_path__ + "7a921dd60180b6f56b5b0ac6695854da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/brown_advisory_funds.png
// module id = 1640
// module chunks = 0